import { CATEGORIES } from '../containers/LandingPages/landingContent';

/**
 * The event type every listing sits under. Weddings are currently the only one;
 * this constant is where a second event type would start.
 */
export const CATEGORY_LEVEL_1 = 'Hochzeit';

/**
 * URL slug -> Sharetribe categoryLevel2 id.
 *
 * These are the ids from the hosted listing-categories.json.
 *
 * server/marketingRouter.js's ANGEBOTE_REWRITES duplicates this exact map for
 * its own /kategorie/{slug}/angebote redirect. That file is server-side and
 * outside this module's reach, so a change to a category id here must also be
 * made there by hand or the two will drift.
 *
 * Five of the nine differ from both the slug and the label. Sharetribe ignores
 * an unknown categoryLevel2 value and returns the unfiltered set, so getting one
 * wrong looks like a working query rather than an error.
 */
export const CATEGORY_KEYS = {
  beauty: 'BeautyStyling',
  catering: 'Catering',
  planer: 'Dienstleister',
  dekoration: 'Deko',
  eventmaterial: 'EventmaterialDeko',
  fotograf: 'FotoVideo',
  location: 'Location',
  musik: 'MusikUnterhaltung',
  transport: 'Transport',
};

/**
 * The nine categories as the topbar rail needs them: slug, hosted id and German
 * label.
 *
 * Ordered by CATEGORY_KEYS, which is declared in the hosted
 * listing-categories.json order - the order the search page's category filter
 * renders in. Reorder CATEGORY_KEYS to reorder the rail; there is no second copy
 * of the order to keep in step. CATEGORIES keeps its booking-journey order for
 * the landing pages, and still supplies the labels.
 *
 * @returns {Array<{slug: string, id: string, label: string}>}
 */
export const getCategoryList = () =>
  Object.keys(CATEGORY_KEYS)
    .map(slug => CATEGORIES.find(cat => cat.slug === slug))
    .filter(Boolean)
    .map(cat => ({ slug: cat.slug, id: CATEGORY_KEYS[cat.slug], label: cat.label }));

/**
 * The same categories in CATEGORIES' booking-journey order (Location first).
 *
 * @returns {Array<{slug: string, id: string, label: string}>}
 */
export const getCategoryJourney = () =>
  CATEGORIES.filter(cat => CATEGORY_KEYS[cat.slug]).map(cat => ({
    slug: cat.slug,
    id: CATEGORY_KEYS[cat.slug],
    label: cat.label,
  }));
